var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeposit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6109_26626)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 9.5H2C1.44772 9.5 1 9.94772 1 10.5V16.5C1 17.0523 1.44772 17.5 2 17.5H16C16.5523 17.5 17 17.0523 17 16.5V10.5C17 9.94772 16.5523 9.5 16 9.5H15V10.7H15.8V16.3H2.2V10.7H3V9.5Z",
    fill: "#141BEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7.5,
    r: 4.6,
    stroke: "#141BEB",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12.5L14 12.5",
    stroke: "#141BEB",
    strokeWidth: 0.929922,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9.5,
    width: 2,
    height: 1.2,
    rx: 0.6,
    fill: "#141BEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 9.5,
    width: 2,
    height: 1.2,
    rx: 0.6,
    fill: "#141BEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6109_26626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16.6154,
    fill: "white",
    transform: "translate(0 0.691406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.674f426609b4b7634aa83db7cd8ee1fa.svg";
export { ForwardRef as ReactComponent };